import request from '@/utils/request'


// 查询用户推荐信息列表
export function listRecommend(query) {
  return request({
    url: '/user/recommend/list',
    method: 'get',
    params: query
  })
}

// 查询用户推荐信息分页
export function pageRecommend(query) {
  return request({
    url: '/user/recommend/page',
    method: 'get',
    params: query
  })
}

// 查询用户推荐信息详细
export function getRecommend(data) {
  return request({
    url: '/user/recommend/detail',
    method: 'get',
    params: data
  })
}

// 新增用户推荐信息
export function addRecommend(data) {
  return request({
    url: '/user/recommend/add',
    method: 'post',
    data: data
  })
}

// 修改用户推荐信息
export function updateRecommend(data) {
  return request({
    url: '/user/recommend/edit',
    method: 'post',
    data: data
  })
}

// 删除用户推荐信息
export function delRecommend(data) {
  return request({
    url: '/user/recommend/delete',
    method: 'post',
    data: data
  })
}
